import { MutableRefObject, useEffect, useRef } from 'react'

export const useClickOutside = <T extends HTMLElement>(
  onOutside: () => void
): MutableRefObject<T | null> => {
  const ref = useRef<T | null>(null)
  const callbackRef = useRef(onOutside)

  useEffect(() => {
    callbackRef.current = onOutside
  }, [onOutside])

  useEffect(() => {
    const handleMouseDown = (event: MouseEvent) => {
      if (!ref.current) return

      if (!event.composedPath().includes(ref.current)) {
        callbackRef.current()
      }
    }
    document.addEventListener('mousedown', handleMouseDown)
    return () => document.removeEventListener('mousedown', handleMouseDown)
  }, [])

  return ref
}
